var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"icon iconButton",on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/notification')}}},[_c('img',{attrs:{"src":require("@/assets/icon/bell.svg")}}),_c('div',{staticClass:"new"},[_c('span',{staticClass:"fXS white"},[_vm._v(_vm._s(_vm.unreadCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }